import { render, staticRenderFns } from "./CashmereLongImage.vue?vue&type=template&id=7821089c&scoped=true"
import script from "./CashmereLongImage.vue?vue&type=script&lang=js"
export * from "./CashmereLongImage.vue?vue&type=script&lang=js"
import style0 from "./CashmereLongImage.vue?vue&type=style&index=0&id=7821089c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7821089c",
  null
  
)

export default component.exports